import moment from "moment";

export class DailyTask {
    public name: string;
    public duration: number;
    public id: string;

    public constructor(name: string, duration: number, public isBreak: boolean = false) {
        this.name = name;
        this.duration = duration;
        this.id = window.crypto.randomUUID();
    }
}


export interface Timeslot {
    start: Date;
    end: Date;
    title?: string;
    id?: string;
}

let tooManyTasksStopIndex: number | null;

function deepCopyDailyTasksFromList(
    passedDailyTasks: DailyTask[],
    breakTime: number,
) {
    const deepCopiedDailyTasks: DailyTask[] = [];

    let breakIndex = 1;
    passedDailyTasks.forEach((task) => {
        deepCopiedDailyTasks.push({
            name: task.name,
            duration: task.duration,
            id: task.id,
            isBreak: false,
        });

        if (breakTime > 0) {
            deepCopiedDailyTasks.push({
                name: "Break",
                duration: breakTime, 
                isBreak: true,
                id: "toilet"
            })
        }

        breakIndex += 1;
    })

    return deepCopiedDailyTasks;
}

export let dailyTasksAppointments: Timeslot[] = [];
export let occupiedTimes: Timeslot[] = [];

export function BuildTasksSchedule(
    passedDailyTasks: DailyTask[],
    breakTime: number,
    enableTasksBreaking: boolean,
    occupiedTimes: Timeslot[],
    todayWorkTimeStart: Date,
    todayWorkTimeEnd: Date,
) {
    dailyTasksAppointments = [];
    // let dailyTasksAppointments: Timeslot[] = [];
    const dailyTasks = deepCopyDailyTasksFromList(
        passedDailyTasks, breakTime
    );

    const unreacheableTime: Timeslot = {
        start: new Date(6969, 1, 1, 1),
        end: new Date(6969, 1, 1, 2)
    }

    // console.log(unreacheableTime);
    occupiedTimes.push({
        start: new Date(6969, 1, 1, 1),
        end: new Date(6969, 1, 1, 2)
    }); // Temporarily add an unreachable event as end
    // 2 returns so we are removing it in two places

    console.log(occupiedTimes.length);
    console.log(occupiedTimes);
    console.log(occupiedTimes[0]);

    
    console.log(todayWorkTimeStart);
    let trackingTime = moment(todayWorkTimeStart);
    let occupiedTimesNavigationIndex = 0;
    let returnedValue = false;

    dailyTasks.every((task) => {
        let taskDuration = task.duration;
        let nextEndTime = new Date(0); // When TimeRegion A's end time is after B's

        if (enableTasksBreaking) {
            console.log("--------------------------");
            console.log(trackingTime.format('MMMM Do YYYY, h:mm:ss a'));
            console.log(occupiedTimesNavigationIndex);
            // moment is mutable
            while (trackingTime.clone().add(taskDuration, 'minutes').isAfter(moment(occupiedTimes[occupiedTimesNavigationIndex].start))) {
                let availableDuration = moment(occupiedTimes[occupiedTimesNavigationIndex].start).diff(trackingTime, 'minutes');
                if (moment(occupiedTimes[occupiedTimesNavigationIndex].start).isBefore(moment(todayWorkTimeStart))) {
                    // If this task is before work start, reset availableDuration to 0
                    availableDuration = 0;
                }
                if (availableDuration > 0) { // might be negative if next even start time is before tracking time, happens when events overlap
                    taskDuration = taskDuration - availableDuration;
                    if (availableDuration >= 1 && !task.isBreak) {
                        dailyTasksAppointments.push(
                            {
                                start: trackingTime.toDate(),
                                end: occupiedTimes[occupiedTimesNavigationIndex].start,
                                title: task.name,
                                id: task.id,
                            }
                        );
                    }
                }
                if (moment(nextEndTime).isBefore(occupiedTimes[occupiedTimesNavigationIndex].end)) {
                    trackingTime = moment(occupiedTimes[occupiedTimesNavigationIndex].end);
                    nextEndTime = occupiedTimes[occupiedTimesNavigationIndex].end;
                }
                occupiedTimesNavigationIndex++;
            }
            //Once we're done with this loop, we are left with a task of shorter length that can proceed accordingly

        } else {
            while (trackingTime.clone().add(taskDuration, 'minutes').isAfter(moment(occupiedTimes[occupiedTimesNavigationIndex].start))) {
                trackingTime = moment(occupiedTimes[occupiedTimesNavigationIndex].end);
                occupiedTimesNavigationIndex++;
            }
        }

        // Checks if we are going over the daily allocated time 😮
        if (trackingTime.clone().add(taskDuration, 'minute').isAfter(moment(todayWorkTimeEnd))) {
            if (task.isBreak) {
                let nextIdx = dailyTasks.indexOf(task)+1;
                if (nextIdx >= dailyTasks.length) {
                    tooManyTasksStopIndex = null; // if final break doesn't fit we don't care 
                } else {
                    tooManyTasksStopIndex = nextIdx;
                }
            } else {
                tooManyTasksStopIndex = dailyTasks.indexOf(task);
            }
            console.log("Overtime!");
            occupiedTimes.pop();
            return false; // Returns false
        }

        if (!task.isBreak) {
            console.log("Pushing P");
            dailyTasksAppointments.push(
                {
                    start: trackingTime.toDate(),
                    end: trackingTime.clone().add(taskDuration, 'minute').toDate(),
                    title: task.name,
                    id: task.id,
                }
            );
        }

        //trackingTime = | It's mutable so now need
        trackingTime.add(taskDuration, 'minute');
        return true; // must return true if doesn't break;
    });

    console.log("Here now lol");
    tooManyTasksStopIndex = null;

    console.log(dailyTasksAppointments.length);
    dailyTasksAppointments.forEach((task) => {
        console.log(task);
    });

    occupiedTimes.pop(); // Remove the extra
    return dailyTasksAppointments;
}
